var cs = {
  "Add Quantity Breaks to your product page": "Přidejte množstevní slevy na stránku produktu",
  "Add Upsell.com to your ": "Přidejte Upsell.com na svou ",
  "Add to cart click": "Kliknutí na Přidat do košíku",
  "All time": "Celé období",
  "and select": "a vyberte",
  "button": "tlačítko",
  "Cart drawer page": "Stránka Výsuvný košík",
  "Cart page": "Stránka Košík",
  "Check status": "Zkontrolovat stav",
  "Checkout page": "Stránka Pokladna",
  "Checkout click": "Kliknutí na Pokladna",
  "Click": "Klikněte na",
  "Click on": "Klikněte na",
  "Click the": "Klikněte na",
  "Custom slot": "Vlastní slot",
  "Custom slots": "Vlastní sloty",
  "Custom Slots": "Vlastní sloty",
  "Enable in theme editor": "Povolit v editoru šablony",
  "contact support.": "kontaktujte podporu.",
  "from the right sidebar": "z pravého postranního panelu",
  "Go to App Embeds": "Přejít na vložení aplikací",
  "Go to your Cart drawer page": "Přejděte na stránku Výsuvný košík",
  "Go to your Cart page": "Přejděte na stránku Košík",
  "Go to your Checkout page": "Přejděte na stránku Pokladna",
  "Go to your Order status page": "Přejděte na stránku Stav objednávky",
  "Go to your Post purchase page": "Přejděte na stránku Po nákupu",
  "Go to your Product page": "Přejděte na stránku Produktu",
  "Go to your Thank you page": "Přejděte na stránku Děkujeme",
  "items": "položky",
  "in the left sidebar": "v levém postranním panelu",
  "Last 12 months": "Posledních 12 měsíců",
  "Last 30 days": "Posledních 30 dní",
  "Last 365 days": "Posledních 365 dní",
  "Last 7 days": "Posledních 7 dní",
  "Last 90 days": "Posledních 90 dní",
  "Last month": "Minulý měsíc",
  "Last year": "Minulý rok",
  "Make sure": "Ujistěte se",
  "Need assistance? Contact our support team for help.": "Potřebujete pomoc? Kontaktujte náš tým podpory.",
  "Order status page": "Stránka Stav objednávky",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Naše aplikace právě prochází malou úpravou, abychom vylepšili váš zážitek.",
  "Post purchase page": "Stránka Po nákupu",
  "Product page": "Stránka Produktu",
  "Save": "Uložit",
  "Scroll to the bottom and select": "Přejděte dolů a vyberte",
  "Select": "Vybrat",
  "Success. Please continue.": "Úspěch. Pokračujte prosím.",
  "Thank you page": "Stránka Děkujeme",
  "The Upsell.com team.": "Tým Upsell.com.",
  "The Upsell.com widget is not placed on ": "Widget Upsell.com není umístěn na ",
  ". Please follow the steps above or ": ". Postupujte podle výše uvedených kroků nebo ",
  "Today": "Dnes",
  "toggle is on": "přepínač je zapnutý",
  "Total": "Celkem",
  "under": "pod",
  "We apologize for any inconvenience caused,": "Omlouváme se za případné nepříjemnosti,",
  "We apologize for any inconvenience caused.": "Omlouváme se za případné nepříjemnosti.",
  "We'll be done in a few minutes!": "Budeme hotovi za pár minut!",
  "We're improving our services!": "Vylepšujeme naše služby!",
  "Widget already added": "Widget již byl přidán",
  "Yesterday": "Včera",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Widget jste zapnuli ve svém online obchodě, ale neuložili jste jej v editoru Upsell",
  "You placed the widget on the ": "Umístili jste widget na ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", ale neuložili jste ho v editoru Shopify. Vraťte se prosím na ",
  " and save the changes.": " a uložte změny."
};

export { cs as default };
//# sourceMappingURL=cs.json.js.map
